(() => {
  const revealTerms = () => {
    if (!['#member-terms', '#welcome-offer-terms'].includes(location.hash)) return;
    const details = document.querySelector('.wl-join ' + location.hash);
    if (!details) return;
    details.open = true;
    details.scrollIntoView({ block: 'start' });
  };
  window.addEventListener('hashchange', revealTerms);
  document.querySelector('.wl-join')?.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (link && new URL(link.href).hash === location.hash) revealTerms();
  });
  revealTerms();
})();
